import { FacilitySortOption } from '@rematter/frontend-lib-api-client';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type FacilityRecord = QueryAtomResult<
  typeof facilitiesQueryAtom
>['facilities'][number];

export const facilitiesQueryAtom = createQueryAtomFactory(
  'trade.facilities',
  (params: {
    searchTerm?: string;
    sorting?: FacilitySortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    facilities: {
      __args: {
        filter: {
          ...(params.searchTerm ? { searchTerm: params.searchTerm } : {}),
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        __typename: true,
        id: true,
        facilityName: true,
        address: {
          __scalar: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data) => ({
      facilities:
        data?.facilities.entries.map((facility) => ({
          id: facility.id,
          facilityName: facility.facilityName,
          address: facility.address
            ? {
                streetAddress: facility.address.streetAddress,
                city: facility.address.city,
                state: facility.address.state,
                country: facility.address.country,
                postalCode: facility.address.postalCode,
                isMailingAddress: facility.address.isMailingAddress,
              }
            : undefined,
        })) ?? [],
      total: data?.facilities.page.total ?? undefined,
    }),
  },
);
